import { render, staticRenderFns } from "./LedgerItem.vue?vue&type=template&id=f26dfbbc&"
import script from "./LedgerItem.vue?vue&type=script&lang=js&"
export * from "./LedgerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports